/**
 * ODX: Prefer first in-stock variant for the selected color (option index 0), in the same order
 * as the size/secondary controls in the DOM. Handles sold-out exact matches, invalid combos
 * (!match), and all-OOS color (last resort: first variant for that color in picker order).
 * URL sync (syncFromVariantId) keeps exact variant via _odxSkipAvailableFallback.
 * Vendor global.js unchanged.
 *
 * Policy parity: snippets/odx-resolve-link-variant-id.liquid (cards / home). That uses
 * product.variants order; here we use DOM order for secondary options when possible.
 */
(function () {
  function optionValue(variant, index) {
    if (variant.options && variant.options[index] != null && variant.options[index] !== "") {
      return variant.options[index];
    }
    if (index === 0) return variant.option1;
    if (index === 1) return variant.option2;
    if (index === 2) return variant.option3;
    return null;
  }

  function getDomOptionOrder(host, optionIndex) {
    var optionContainers = Array.from(
      host.querySelectorAll(
        "fieldset.js.product-form__input, .product-form__input select",
      ),
    );
    var el = optionContainers[optionIndex];
    if (!el) return [];
    if (el.tagName === "SELECT") {
      return Array.from(el.options).map(function (o) {
        return o.value;
      });
    }
    return Array.from(el.querySelectorAll('input[type="radio"]')).map(function (r) {
      return r.value;
    });
  }

  function sortVariantsByPickerOrder(host, variants, optionIndex) {
    var order = getDomOptionOrder(host, optionIndex);
    if (!order.length) return variants.slice();
    var rank = {};
    order.forEach(function (val, i) {
      if (rank[val] === undefined) rank[val] = i;
    });
    return variants.slice().sort(function (a, b) {
      var av = optionValue(a, optionIndex);
      var bv = optionValue(b, optionIndex);
      var ra = rank[av] !== undefined ? rank[av] : 9999;
      var rb = rank[bv] !== undefined ? rank[bv] : 9999;
      return ra - rb;
    });
  }

  function applyVariantSelectionToDom(host, variant) {
    var optionValues = Array.isArray(variant.options)
      ? variant.options
      : [variant.option1, variant.option2, variant.option3].filter(Boolean);
    var optionContainers = Array.from(
      host.querySelectorAll(
        "fieldset.js.product-form__input, .product-form__input select",
      ),
    );
    optionValues.forEach(function (value, index) {
      if (value == null) return;
      var el = optionContainers[index];
      if (!el) return;
      if (el.tagName === "SELECT") {
        if (el.value !== value) el.value = value;
        return;
      }
      var radio = Array.from(el.querySelectorAll('input[type="radio"]')).find(
        function (r) {
          return r.value === value;
        },
      );
      if (radio && !radio.checked) radio.checked = true;
    });
  }

  var Ctor = customElements.get("variant-selects");
  if (!Ctor || !Ctor.prototype.updateMasterId || !Ctor.prototype.syncFromVariantId) {
    return;
  }

  var origSyncFromVariantId = Ctor.prototype.syncFromVariantId;

  Ctor.prototype.syncFromVariantId = function (variantId, options) {
    this._odxSkipAvailableFallback = true;
    try {
      return origSyncFromVariantId.call(this, variantId, options);
    } finally {
      this._odxSkipAvailableFallback = false;
    }
  };

  Ctor.prototype.updateMasterId = function () {
    var self = this;
    var skipFallback = this._odxSkipAvailableFallback === true;
    var variants = this.getVariantData();

    var match = variants.find(function (variant) {
      if (!variant.options) return false;
      return !variant.options
        .map(function (option, index) {
          return self.options[index] === option;
        })
        .includes(false);
    });

    if (skipFallback) {
      this.currentVariant = match;
      return;
    }

    var colorKey = self.options[0];

    function sameColor(v, key) {
      return optionValue(v, 0) === key;
    }

    /** First available for color, else first any (OOS) for color; order follows DOM for option index 1+ */
    function pickForColor(key) {
      var available = variants.filter(function (v) {
        return sameColor(v, key) && v.available;
      });
      var sortedAvail = sortVariantsByPickerOrder(self, available, 1);
      if (sortedAvail.length > 0) return sortedAvail[0];
      var any = variants.filter(function (v) {
        return sameColor(v, key);
      });
      var sortedAny = sortVariantsByPickerOrder(self, any, 1);
      return sortedAny[0] || null;
    }

    if (!match) {
      if (colorKey == null) {
        this.currentVariant = undefined;
        return;
      }
      var pickedNoMatch = pickForColor(colorKey);
      if (!pickedNoMatch) {
        this.currentVariant = undefined;
        return;
      }
      applyVariantSelectionToDom(this, pickedNoMatch);
      this.updateOptions();
      this.currentVariant = pickedNoMatch;
      return;
    }

    if (match.available) {
      this.currentVariant = match;
      return;
    }

    var picked = pickForColor(colorKey);
    if (!picked || picked.id === match.id) {
      this.currentVariant = match;
      return;
    }

    applyVariantSelectionToDom(this, picked);
    this.updateOptions();
    this.currentVariant = picked;
  };
})();
